import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

function NavigationCard({ bgColor = "white", title, count, link, icon, direction }) {
  return (
    <Card>
      <Link to={link ? link : "#"}>
        <SuiBox bgColor={bgColor} variant="gradient">
          <SuiBox px={1.5} py={1}>
            <Grid container alignItems="center">
              {direction === "left" ? (
                <Grid item>
                  <SuiBox
                    variant="gradient"
                    bgColor={bgColor === "white" ? icon.color : "white"}
                    color={bgColor === "white" ? "white" : "dark"}
                    width="2.3rem"
                    height="2.3rem"
                    borderRadius="md"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    shadow="md"
                  >
                    {icon.component}
                  </SuiBox>
                </Grid>
              ) : null}
              <Grid item xs={8}>
                <SuiBox ml={direction === "left" ? 2 : 0} lineHeight={1}>
                  <SuiTypography
                    variant="h6"
                    color={bgColor === "white" ? "text" : "white"}
                    // opacity={bgColor === "white" ? 1 : 0.7}
                    textTransform="capitalize"
                    fontWeight={title.fontWeight}
                    lineHeight={1.2}
                  >
                    {title.text}
                  </SuiTypography>
                </SuiBox>
              </Grid>
              {direction === "right" ? (
                <Grid item xs={4}>
                  <SuiBox
                    variant="gradient"
                    bgColor={bgColor === "white" ? icon.color : "white"}
                    color={bgColor === "white" ? "white" : "dark"}
                    width="2.3rem"
                    height="2.3rem"
                    marginLeft="auto"
                    borderRadius="md"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    shadow="md"
                  >
                    {icon.component}
                  </SuiBox>
                </Grid>
              ) : null}
            </Grid>
          </SuiBox>
        </SuiBox>
      </Link>
    </Card>
  );
}

export default NavigationCard;
